module.exports = __webpack_public_path__ + "img/yxz.9d6cb88b.png";